import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { LOGIN_PAGE } from '@/types/router'
import faqRoutes from '@/router/sections/faq'
import authRoutes from '@/router/sections/auth'
import infoRoutes from '@/router/sections/info'
import staffRoutes from '@/router/sections/staff'
import customerRoutes from '@/router/sections/customer'
import uncategorizedRoutes from '@/router/sections/uncategorized'

const routes: Array<RouteRecordRaw> = [
  ...authRoutes,
  ...infoRoutes,
  ...faqRoutes,
  ...staffRoutes,
  ...customerRoutes,
  ...uncategorizedRoutes,
]

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach((to) => {
  const authStore = useAuthStore()
  const isGuestRoute = to.meta?.guest || to.meta?.auth === false
  const isAuthenticated = authStore.authenticated || !!localStorage.getItem('id_token')

  if (isAuthenticated || isGuestRoute) {
    return true
  }

  if (to.name === LOGIN_PAGE) {
    return true
  }

  const redirectPath = to.fullPath

  return {
    name: LOGIN_PAGE,
    query: redirectPath !== '/' ? { redirect: redirectPath } : undefined,
  }
})

router.afterEach((to) => {
  document.title = String(to.meta.title || 'PacSort – 21grams')
})
export default router
